export default __webpack_public_path__ + "static/media/login-background.abb94b84.png";